<template>
  <div class="row noWrap">
    <div class="col label" style="flex-grow: 1.5;">
      <!-- <div class="vKeyboard">
        <slot name="keyboardSlot" />
      </div> -->
      <slot name="label" />

    </div>
    <div class="col" style="flex-grow: 1.5; padding: 0;">
      <slot name="selection" />
    </div>
    <div class="col" style="padding-right: 0; flex: 2; justify-content: center; display:flex;">
      <slot name="submit"/>
    </div>
  </div>
</template>

<!-- <div class="row q-px-md" :class="noPad ? '' : 'q-mt-md'"></div> -->

<script>
export default {
  props: {
    noPad: {
      default: false,
      type: Boolean
    }
  },
}
</script>

<style lang="scss" scoped>
.label {
  // padding-top: 20px;
  padding-left: 10px;
}

@media (min-height:768px) {
  .label {
    padding-left: 16px;
    padding-right: 0;
  }
}

* {
  flex: 1;
}

.row {
  margin: 0 !important;
  max-height: 61px;
}

.noWrap {
  flex-wrap: nowrap;
  justify-content: space-between !important;
  // align-items: center;
}

.vKeyboard {
  position: relative;
  left:0% !important;
  top: 20px;
  width: 316px;
}

</style>